import { Component, Inject, QueryList, ViewChildren } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SubMenuCardModel } from 'src/app/client/DbModel/SubMenuCard/Submenucardmodel';
import { CommonService } from 'src/app/core/services/commonservices';
import { DataShareService } from 'src/app/core/services/datashare.service';
import { VitalHttpServices } from 'src/app/core/services/VitalHttpServices';
import { MatChipInputEvent } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import * as wjcCore from '@grapecity/wijmo';
import { CollectionView } from '@grapecity/wijmo';
import { DialogService } from 'src/app/core/services/dialog.service';
import { ConfirmLabadminComponent } from 'src/app/base/popup/confirm-labadmin/confirm-labadmin.component';
import { NgModel } from '@angular/forms';

@Component({
  selector: 'app-orderand-reult-code-mapper',
  templateUrl: './orderand-reult-code-mapper.component.html',
  styleUrls: ['./orderand-reult-code-mapper.component.scss']
})
export class OrderandResultCodeMapperComponent {
  subMenuCardModel: any;
  SubMenuCardModel: any;
  selectedFormValues: {
    IsAutoRelease: boolean;
    InstrumentCode: string;
    OrderCodeName: string;
    OrderCodeID: number;
    OrderCode: string;
    DisplayName: string;
    InstrumentTestCode: any;
    InstrumentResultCodeIgnore: string;
    SendToDevice: string;
    InstrumentID:number
    InstrumentOrderCodeID:number
  } = {
      IsAutoRelease: true,
      InstrumentCode: '',
      OrderCodeName: '',
      OrderCodeID: 0,
      OrderCode: '',
      DisplayName: '',
      InstrumentTestCode: [],
      InstrumentResultCodeIgnore: '',
      SendToDevice: 'OrderCode',
      InstrumentID:0,
      InstrumentOrderCodeID:0
    };
  selectedResultFormValues: {
    ID: number;
    ResultCodeId: number;
    InstrumentId: number;
    InstrumentTestCode: string;
    ImportResultProperties: string;
    OrderToDevice: boolean;
    ResultCode: string;
    Importresultconfiguration: string;
    ImportresultconfigurationType: string;
    OrderCodeID:number

  } = {
      ID: 0,
      ResultCodeId: 0,
      InstrumentId: 0,
      InstrumentTestCode: '',
      ImportResultProperties: 'OverWrite',
      OrderToDevice: true,
      ResultCode: '',
      Importresultconfiguration: '',
      ImportresultconfigurationType: 'None',
      OrderCodeID:0
    };

  mainFormOrderCodeFields: any = {
    EnableAutoRelease: true,
    instrumentcode: '',
    OrderCodeName: '',
    instrumentOrderCodes: '',
    instrumentResultCodes: ''
  };
  selectedOrderCodeName: any;
  selectedResultCodeName: any;
  OrderCodeNameList: any;
  ResultCodeNameList: { ResultCode: string, ResultCodeId: number }[] = [];
  isFormChanged = false;
  isFormResultCodeChanges=false;
  orderCode = 'OrderCode';
  separatorKeysCodes: number[] = [ENTER, COMMA];
  instrumentOrderCodes: string[] = [];
  instrumentResultCodes: string[] = [];
  gridheader: string[];
  gridData: wjcCore.CollectionView<any>;
  noDataFound: boolean;
  gridHeaderList: any;
  listedGridHeader: any;
  listHeaderbackup: any;
  editBtn: boolean = false;
  createBtn: boolean = false;
  exportBtn: boolean = false;
  deleteBtn: boolean = false;
  createPage: boolean;
  oldData: any;
  sourceApp = 'VitalDx';
  @ViewChildren(NgModel) inputFields!: QueryList<NgModel>;

  ///Result code mapper
  mainFormResultCodeFields: any = {
    resultMapping: false,
    resultCode: '',
    OrderCodeName: '',
    instrumentResultCodesMapper: ''
  };
  isSaveDisabled: boolean = false;
  action: string;

  // Result Properties related properties
  showAdditionAttr: boolean = false;
  ShowResultPropertiesTypes: boolean = false;
  isABRGen: boolean = false;
  showSlop: boolean = false;
  showeamp: boolean = true;

  // Result Properties arrays
  ResultProperties: any[] = [
    { name: 'None', alias: 'None', value: true },
    { name: 'All', alias: 'All', value: false },
    { name: 'Custom', alias: 'Custom', value: false }
  ];

  ResultAttributes = [
    { name: 'EMP', alias: 'EMP', value: true },
     { name: 'SLOPE',alias: 'SLOPE',value: false }, 
     {name: 'CT Range',alias: 'CT Range',value: false}
    ];

  ResultPropertiesCustom: any[] = [
    { name: 'Unit of Measurment', alias: 'Unit', value: false },
    { name: 'Result Flag', alias: 'Flag', value: false },
    { name: 'Reference Range', alias: 'ReferenceRange', value: false },
    { name: 'Result Comments', alias: 'Comments', value: false }
  ];
  // Attribute properties
  AttributeCrt: string = '';
  AttributeCrtSD: string = '';
  AttributeAmpScore: string = '';
  AttributeCqConf: string = '';
  AttributeSlop: string = '';
  AttributeeAmp: string = '';
  AttributeIntercept: string = '';

  // CT Records
  CTRecords: any[] = [{ range: '', value: '' }];
  resultArray: any;

  filteredOrderCodeNameList: any[] = [];
  searchOrderCodeText: string = '';
  readonly INITIAL_DISPLAY_COUNT = 50;
  showSearch: boolean = false;
  ImportResultProperties: string = 'OverWrite';
  ResultPropertiesSelected = 'None'
  public XML = '';
  gridShow: boolean;
  saveOrEditCompleted: number;
  sourcetype: any;

  constructor(
    private datashare: DataShareService,
    public VitalHttpServices: VitalHttpServices,
    public commonService: CommonService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _snackbar: MatSnackBar,
    private dialogRef: MatDialogRef<OrderandResultCodeMapperComponent>,
    private matdialog: DialogService,
    private dialog: MatDialog
  ) {
    this.SubMenuCardModel = new SubMenuCardModel(commonService, VitalHttpServices, datashare);
  }



  async ngOnInit() {
    this.sourcetype = this.data.sourcetype
    if (this.data?.EditData) {
      this.orderCode = this.data.EditData.SendToDevice;
      this.mainFormOrderCodeFields.instrumentcode = this.data.EditData.InstrumentCode;
      for(let i = 0;i<this.data.templateData.submenuData.length;i++){
        if(this.data.EditData.OrderCodeID == this.data.templateData.submenuData[i].OrderCodeID ){
          if (this.data.templateData.submenuData[i].matchingInsTestCodeName) {
            this.data.templateData.submenuData[i].matchingInsTestCodeName.forEach(element => {
              if (element.OrderCodeId == this.data.EditData.OrderCodeID) {
                if (this.InsCodes.length == 0) {
                  this.InsCodes.push({
                    "instOrderCode": element.InstrumentTestCode,
                    "instOrderName": element.InstrumentTestName
                  })
                } else {
                  let includes = false;
                  for (let io = 0; io < this.InsCodes.length; io++) {
                    if (this.InsCodes[io].instOrderCode == element.InstrumentTestCode && this.InsCodes[io].instOrderName == element.InstrumentTestName) {
                      includes = true;
                      break;
                    } else {
                      includes = false;
                    }
                  }
                  if (!includes) {
                    this.InsCodes.push({
                      "instOrderCode": element.InstrumentTestCode,
                      "instOrderName": element.InstrumentTestName
                    })
                  }
                }
              }
            });
          } else if (this.data.templateData.submenuData[i].InstrumentTestCode.length > 0) {
            console.log(this.data.templateData.submenuData[i].InstrumentTestCode);
            var tempInsCodes = JSON.parse(this.data.templateData.submenuData[i].InstrumentTestCode);
            this.InsCodes = tempInsCodes.InstrumentTestCode;
          }
        }
      }
      this.addGridData(this.data.ResultCodeMapperList);
    }
    else {
      this.resetOrderCodeFrom();
      this.addGridData([]);
      this.mainFormOrderCodeFields.instrumentcode = this.data.InstrumentName;
      this.orderCode = 'OrderCode';
    }
    this.getOrdercodeList();
    this.initializeFormData();
    if (this.InsCodes.length == 0) {
      this.addCodes();
    }
    setTimeout(() => {
      if (this.InsCodes.length > 0) {
        for (let ii = 0; ii < this.InsCodes.length; ii++) {
          (<HTMLInputElement>document.getElementById('insorderCode' + ii)).value = this.InsCodes[ii].instOrderCode;
          (<HTMLInputElement>document.getElementById('insorderText' + ii)).value = this.InsCodes[ii].instOrderName;
        }
      }
    }, 100);
  }

  resetOrderCodeFrom(){
    this.mainFormOrderCodeFields = {
      EnableAutoRelease: true,
      instrumentcode: '',
      OrderCodeName: '',
      instrumentOrderCodes: '',
      instrumentResultCodes: ''
    };
    this.selectedOrderCodeName=''
  }

  initializeFormData() {
    // Initialize from existing data if available
    if (this.data?.EditData) {
     // this.mainFormOrderCodeFields = { ...this.data.EditData };
      this.mainFormOrderCodeFields.instrumentcode = this.data.EditData.InstrumentCode;
      this.selectedOrderCodeName = this.data.EditData.DisplayName;
      this.instrumentOrderCodes = this.data.EditData.InstrumentTestCode.split(',').map(code => code.trim()).filter(code => code);
      this.instrumentResultCodes = this.data.EditData.InstrumentResultCodeIgnore.split(',').map(code => code.trim()).filter(code => code);
      this.mainFormOrderCodeFields.EnableAutoRelease=this.data.EditData.IsAutoRelease;
    }
  }

  onOrderCodeNameChange() {
    this.mainFormOrderCodeFields.OrderCodeName = this.selectedOrderCodeName;
    this.isFormChanged = true;
  }

  onResultCodeNameChange() {
    this.mainFormResultCodeFields.resultCode = this.selectedResultCodeName;
    this.isFormResultCodeChanges = true;
  }

  getOrdercodeList() {
    let query = this.SubMenuCardModel.GetQuery('getOrdercodeNameForInstrumnet');
    let queryVariable = {
      "orgid": this.data.selecteddefaultorgid.toString()
    }

    let queryResult = this.commonService.GetCardRequest(queryVariable, query);
    this.VitalHttpServices.GetData(queryResult, this.data.deploymentkey).subscribe((fieldRes) => {
      if (fieldRes?.errors) {
        console.error('Error fetching Order code list for Order code Name:', fieldRes.errors);
        return;
      }

      const submenuDataField = fieldRes?.data?.submenuData;
      if (submenuDataField) {
        try {
          this.OrderCodeNameList = fieldRes?.data?.submenuData;
          this.filteredOrderCodeNameList = this.OrderCodeNameList.slice(0, this.INITIAL_DISPLAY_COUNT);
          if (this.data?.EditData) { this.showSearch = true; this.selectedOrderCodeName = this.filteredOrderCodeNameList.find(x => x.DisplayName === this.selectedOrderCodeName); }
        } catch (error) {
          console.error('Error parsing representing fields data:', error);
        }
      }
    });
  }

  onDropdownOpened(isOpen: boolean) {
    if (isOpen && this.OrderCodeNameList?.length > this.INITIAL_DISPLAY_COUNT) {
      this.showSearch = true;
    } else {
      this.showSearch = false;
    }
  }

  filterOrderCodes(searchText: string) {
    this.searchOrderCodeText = searchText;
    if (!searchText) {
      this.filteredOrderCodeNameList = this.OrderCodeNameList.slice(0, this.INITIAL_DISPLAY_COUNT);
    } else {
      this.filteredOrderCodeNameList = this.OrderCodeNameList.filter(option =>
        option.Name.toLowerCase().includes(searchText.toLowerCase())
      );
    }
  }
  // Function to compare selected value with list
  compareByName = (a: any, b: any) => a?.Name === b?.Name;
  trimField(ruleName: any, value: any) {
    this.mainFormOrderCodeFields[ruleName] = value ? value?.trim() : value;
  }

  toggleInstrumentType(type) {
    this.orderCode = this.orderCode === "OrderCode" ? "ResultCode" : "OrderCode";
    if (this.data ?.EditData) {
      this.addGridData(this.data.ResultCodeMapperList);
    }
    else {
      this.addGridData(this.data.ResultCodeMapperList);
    }
    if (type == 'OrderCode') {
      if (this.InsCodes.length == 0) {
        this.addCodes();
      }
      setTimeout(() => {
        if (this.InsCodes.length > 0) {
          for (let ii = 0; ii < this.InsCodes.length; ii++) {
            (<HTMLInputElement>document.getElementById('insorderCode' + ii)).value = this.InsCodes[ii].instOrderCode;
            (<HTMLInputElement>document.getElementById('insorderText' + ii)).value = this.InsCodes[ii].instOrderName;
          }
        }
      }, 100);
    }
  }

  addOrderCode(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      this.instrumentOrderCodes.push(value);
      this.mainFormOrderCodeFields['instrumentOrderCodes'] = this.instrumentOrderCodes.join(',');
      this.isFormChanged = true;
    }
    event.chipInput!.clear();
  }

  removeOrderCode(code: string): void {
    const index = this.instrumentOrderCodes.indexOf(code);
    if (index >= 0) {
      this.instrumentOrderCodes.splice(index, 1);
      this.mainFormOrderCodeFields['instrumentOrderCodes'] = this.instrumentOrderCodes.join(',');
      this.isFormChanged = true;
    }
  }

  addInstrumentResultCode(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if (value) {
      this.instrumentResultCodes.push(value);
      this.mainFormOrderCodeFields['instrumentResultCodes'] = this.instrumentResultCodes.join(',');
      this.isFormChanged = true;
    }
    event.chipInput!.clear();
  }

  removeResultCode(code: string): void {
    const index = this.instrumentResultCodes.indexOf(code);
    if (index >= 0) {
      this.instrumentResultCodes.splice(index, 1);
      this.mainFormOrderCodeFields['instrumentResultCodes'] = this.instrumentResultCodes.join(',');
      this.isFormChanged = true;
    }
  }

  validateInsTestCodes() {
    for (let i = 0; i < this.InsCodes.length; i++) {
      if (this.InsCodes[i].instOrderName.trim() != '' && this.InsCodes[i].instOrderCode.trim() == '') {
        return true;
      }
      if (this.InsCodes[i].instOrderName.trim() == '' && this.InsCodes[i].instOrderCode.trim() == '') {
        if (this.InsCodes.length == 1)
          return false;
        else
          return true;
      }
    }
    return false;
  }

  saveChanges() {
      if (this.validateInsTestCodes()) {
        this._snackbar?.open('Please add the Instrument OrderCode data', null, {
          duration: 3000,
          panelClass: ['warning-snackbar']
        });
        return;
      }
    // Update the main form fields with the latest chip values
    this.mainFormOrderCodeFields.instrumentOrderCodes = this.instrumentOrderCodes.join(',');
    this.mainFormOrderCodeFields.instrumentResultCodes = this.instrumentResultCodes.join(',');
    this.InsCodes;
    // Store values in global variable
    this.selectedFormValues = {
      IsAutoRelease: this.mainFormOrderCodeFields.EnableAutoRelease,
      InstrumentCode: this.mainFormOrderCodeFields.instrumentcode,
      OrderCodeName: this.selectedOrderCodeName.Name ?? this.mainFormOrderCodeFields.OrderCodeName?.Name,
      OrderCodeID: this.selectedOrderCodeName.OrderCodeID ?? this.mainFormOrderCodeFields.OrderCodeName?.OrderCodeID,
      OrderCode: this.selectedOrderCodeName.OrderCode ?? this.mainFormOrderCodeFields.OrderCodeName?.OrderCode,
      DisplayName: this.selectedOrderCodeName.DisplayName ?? this.mainFormOrderCodeFields.OrderCodeName?.DisplayName,
      InstrumentTestCode: JSON.stringify({ "InstrumentTestCode": this.InsCodes }),
      InstrumentResultCodeIgnore: this.mainFormOrderCodeFields.instrumentResultCodes,
      SendToDevice: this.orderCode,
      InstrumentID:this.data?.EditData?.InstrumentID ?? 0,
      InstrumentOrderCodeID:this.data?.EditData?.InstrumentOrderCodeID ?? 0
    };
    let Object = {
      "OrderCodeData": this.selectedFormValues,
      "ResultCodeData": this.data.ResultCodeMapperList
    }
    // Close dialog and return the form data
    this.dialogRef.close(Object);
  }

  addGridData(templateData: any) {
    let primary = {};
    if (this.orderCode != 'OrderCode') {
      if(this.sourcetype != 'SendOutLabs'){
        this.gridHeaderList = ['Result Code', 'Instrument Result Code', 'Retain Result Properties From', 'Use Only for Result Mapping']
      }
      else{
        this.gridHeaderList = ['Result Code', 'Target Result Code', 'Retain Result Properties From', 'Use Only for Result Mapping']
      }
    }
    else {
      if(this.sourcetype != 'SendOutLabs'){
      this.gridHeaderList = ['Result Code', 'Instrument Result Code', 'Retain Result Properties From']
      }
      else{
        this.gridHeaderList = ['Result Code', 'Target Result Code', 'Retain Result Properties From'] 
      }
    }

    // Patch into listedGridHeader
    this.listedGridHeader = this.gridHeaderList.map((header, index) => {
      let key;
      switch (header) {
        case 'Result Code':
          key = 'ResultCode';
          break;
        case 'Instrument Result Code':
          key = 'InstrumentTestCode';
          break;
        case 'Target Result Code':
          key = 'InstrumentTestCode';
          break;
        case 'Retain Result Properties From':
          key = 'ImportresultconfigurationType';
          break;
        case 'Use Only for Result Mapping':
          key = 'OrderToDevice';
          break;
        default:
          key = header.replace(/\s+/g, '').toLowerCase();
      }
      return {
        Name: header,
        type: 'input',
        key: key,
        colWidth: (header === 'Retain Result Properties From' || header === 'Use Only for Result Mapping') ? 'col-sm-3' : 'col-sm-2'
      };
    });


    let gridarray = [];
    this.gridheader = [
      'ID',
      'ResultCodeId',
      'InstrumentId',
      'InstrumentTestCode',
      'ImportResultProperties',
      'OrderToDevice',
      'ResultCode',
      'Importresultconfiguration',
      'ImportresultconfigurationType',
      'OrderCodeID'
    ];
    for (let i = 0; i < templateData.length; i++) {
      primary = {};
      for (let [key, value] of Object.entries(templateData[i])) {
        if (key == 'InstrumentCode') {
          if (value == '' || value == null) {
            value = 'Not Specified';
            primary[key] = value;
          }
          primary[key] = value;
        }
        for (let j = 0; j < this.gridheader.length; j++) {
          if (key === this.gridheader[j]) {
            primary[key] = value;
          }
        }
      }
      gridarray.push(primary);
    }
    this.gridData = new CollectionView(gridarray);
    this.gridShow = true;
    this.noDataFound = false;
    return gridarray;
  }
  async createResultOrderCodeMapper(event: any, action: string) {
    this.action = action;
    if (action == 'create') {
      if (!this.selectedOrderCodeName?.OrderCodeID) {
        // this._snackbar.open('Order Code Name is mandatory', 'Close', {
        //   duration: 3000,
        //   panelClass: ['error-snackbar']
        // });
        this._snackbar?.open('Order Code Name is mandatory', null, {
          duration: 3000,
          panelClass: ['warning-snackbar']
        });
  
        this.inputFields.forEach((field) => {
          field.control.markAsTouched();
          field.control.updateValueAndValidity();
        });
        return;
      }
      this.isFormResultCodeChanges=false;
      this.checkforSelectedanalyzer(this.data.Selectedanalyzer)
      this.ResultCodeNameList=[];
      await this.getResultCodeMapperList(this.selectedOrderCodeName?.OrderCodeID);
      this.addResultCode();
      this.resetForm();
      this.createPage = true;
    }
    else {
      this.oldData = event.rowData;
      this.ResultCodeNameList=[];
      this.ShowResultPropertiesTypes=false;
      this.isFormResultCodeChanges=false;
      await this.getResultCodeMapperList(this.selectedOrderCodeName?.OrderCodeID);
      // Patch the old data into the form
      this.mainFormResultCodeFields = {
        resultMapping: this.oldData.OrderToDevice,
        resultCode: {
          ResultCode: this.oldData.ResultCode,
          ResultCodeId: this.oldData.ResultCodeId
        },
        OrderCodeName: '',
        instrumentResultCodesMapper: this.oldData.InstrumentTestCode
      };
      // Set the result properties based on old data
      if (this.oldData.ImportresultconfigurationType) {
        this.ResultPropertiesSelected = this.oldData.ImportresultconfigurationType;
        this.ResultProperties.forEach(prop => {
        if(prop.alias === this.oldData.ImportresultconfigurationType)
          {
            prop.value=true;
          }
          else{
            prop.value=false;
          };
        });
      }
      if (this.oldData.ImportResultProperties) {
        this.ImportResultProperties = this.oldData.ImportResultProperties;
      }
     
      if(this.data?.Selectedanalyzer){
        const jsonData = this.parseXmlToJson(this.oldData.Importresultconfiguration);
        this.checkforSelectedanalyzer(this.data.Selectedanalyzer,jsonData);
        this.createPage = true;
      }
      else{
        let parser = new DOMParser();
        let xmlDoc = parser.parseFromString(this.oldData.Importresultconfiguration, "text/xml");
        this.selectedResultCodeName = this.ResultCodeNameList.find(x => x.ResultCode === this.oldData.ResultCode);
        // Get all <Property> values
        let propertyElements = xmlDoc.getElementsByTagName("Property");
        let extractedAliases = Array.from(propertyElements).map(prop => prop.textContent);
        // Only set all to true if we have no matches and the conditions are met
        if (this.oldData.ImportresultconfigurationType == 'None' && this.oldData.ImportResultProperties == 'OverWrite') {
          this.ResultPropertiesCustom.forEach(element => {
            element.value = true;
          });
        }

        if(this.oldData.ImportresultconfigurationType=='Custom'){ 
          this.ShowResultPropertiesTypes=true;
          this.ResultPropertiesCustom.forEach(item => {
            if (extractedAliases.includes(item.alias)) {
              item.value = true;
            } else {
              item.value = false;
            }
          });
        }
        this.createPage = true;
      }
    }
  }

  getResultCodeMapperList(id): Promise<void> {
    return new Promise((resolve, reject) => {
      const request = {
        OrganizationID: this.data.selecteddefaultorgid,
        InstrumentID: 0,
        OrderCodeID: id,
        Action: 'create' // or 'View'
      };
      this.VitalHttpServices.getInstrumentResultCodes(request, this.data.deploymentkey).subscribe(
        res => {
          if (res.statuscode == 200) {
            this.resultArray = res.content?.InstrumentResults
            this.resultArray.forEach(item => {
              if (item.ResultCode && item.ResultCodeId !== undefined) {
                this.ResultCodeNameList.push({
                  ResultCode: item.ResultCode,
                  ResultCodeId: item.ResultCodeId
                });
              }
            });
            resolve();
          } else {
            reject(new Error('Failed to get result code mapper list'));
          }
        },
        error => {
          console.error(error);
          reject(error);
        });
    });
  }

  trimResultField(ruleName: any, value: any) {
    this.mainFormResultCodeFields[ruleName] = value ? value?.trim() : value;
  }

  goBack() {
    if (this.isFormResultCodeChanges) {
      this.isSaveDisabled = true;
      this.matdialog.openChangesDiscardedDialog('Return', 'Stay on this page')
        .afterClosed().subscribe(result => {
          if (result) {
            this.ShowResultPropertiesTypes = false
            this.isSaveDisabled = false;
            this.createPage = false;
            this.addGridData(this.data.ResultCodeMapperList);
          } else {
            this.isSaveDisabled = false;
            return;
          }
        });
    } else {
      this.ShowResultPropertiesTypes = false
      this.createPage = false;
      this.addGridData(this.data.ResultCodeMapperList);
    }
  }

  // Result Properties Selection
  ResultPropertiesSelect(event: any, data: any,value:any) {
    this.ResultPropertiesSelected = data.alias;
    this.ResultProperties.forEach(element => {
      if (element.alias === data.alias) {
        element.value=value;
        this.ShowResultPropertiesTypes=value
      } else {
        element.value = false;
      }
    });
  
    // Reset custom values
    this.ResultPropertiesCustom.forEach(el => el.value = false);
  
    // Clear XML
    this.XML = null;
  
    // Apply behavior based on alias
    if (data.alias === 'Custom') {
     // this.ShowResultPropertiesTypes = toggledValue;
      this.ImportResultProperties = 'Do not OverWrite';
    } else if (data.alias === 'All') {
      this.ShowResultPropertiesTypes = false;
      this.ImportResultProperties = 'Do not OverWrite';
    } else if (data.alias === 'None') {
      this.ShowResultPropertiesTypes = false;
      this.ImportResultProperties = 'OverWrite';
      this.ResultPropertiesCustom.forEach(el => el.value = true);
    } else {
      this.ShowResultPropertiesTypes = false;
      this.ImportResultProperties = 'Do not OverWrite';
    }
  
    
  }
  
  //Add CT Range
  AddCTRange() {
    // Check if any existing record has empty range or value
    const hasEmptyFields = this.CTRecords.some(record => !record.range || !record.value);
    
    if (hasEmptyFields) {
      // this._snackbar.open('Please fill in all CT Range fields before adding a new one', 'Close', {
      //   duration: 3000,
      //   panelClass: ['error-snackbar']
      // });
      this._snackbar?.open('Please fill in all CT Range fields before adding a new one', null, {
        duration: 3000,
        panelClass: ['warning-snackbar']
      });
      return;
    }
    
    this.CTRecords.push({ range: '', value: '' });
  }
  // Remove Range
  RemoveRange(index: number) {
    if (this.CTRecords.length > 1) {
      this.CTRecords.splice(index, 1);
    }
  }
  // Reset Additional Attributes
  private resetAdditionalAttributes() {
    this.AttributeCrt = '';
    this.AttributeCrtSD = '';
    this.AttributeAmpScore = '';
    this.AttributeCqConf = '';
    this.AttributeSlop = '';
    this.AttributeeAmp = '';
    this.AttributeIntercept = '';
    this.CTRecords = [{ range: '', value: '' }];
    this.ResultPropertiesSelected = 'None'
    this.ImportResultProperties = 'OverWrite';
    this.selectedResultCodeName = '';
    this.ShowResultPropertiesTypes = false;
  }
  SaveResultCode() {
    // Validate required fields
    if (!this.mainFormResultCodeFields.resultCode || !this.mainFormResultCodeFields.instrumentResultCodesMapper) {
      // this._snackbar.open('Please fill in all required fields', 'Close', {
      //   duration: 3000,
      //   panelClass: ['error-snackbar']
      // });
      this._snackbar?.open('Please fill in all required fields', null, {
        duration: 3000,
        panelClass: ['warning-snackbar']
      });

      this.inputFields.forEach((field) => {
        field.control.markAsTouched();
        field.control.updateValueAndValidity();
      });
      return;
    }

    // Check for duplicate Result Code
    const resultCode = this.mainFormResultCodeFields?.resultCode?.ResultCode;
    const isDuplicate = this.data.ResultCodeMapperList.some(item => 
      item.ResultCode === resultCode && 
      (this.action === 'create' || (this.action === 'edit' && item.ID !== this.oldData.ID))
    );

    if (isDuplicate) {
      // this._snackbar.open('Result Code already exists', 'Close', {
      //   duration: 3000,
      //   panelClass: ['error-snackbar']
      // });
      this._snackbar?.open('Result Code already exists', null, {
        duration: 3000,
        panelClass: ['warning-snackbar']
      });

      return;
    }

    var RadioType;
    if (this.showAdditionAttr) {
      var AttrJSON: any;
      RadioType = 'None';
      if (this.showeamp) {
        AttrJSON = this.generateUTIXML('EMP', 'XML', this.AttributeCrt, this.AttributeCrtSD, this.AttributeAmpScore, this.AttributeCqConf, this.AttributeIntercept, this.AttributeeAmp);
      } else if (this.showSlop) {
        AttrJSON = this.generateUTIXML('SLOPE', 'XML', this.AttributeCrt, this.AttributeCrtSD, this.AttributeAmpScore, this.AttributeCqConf, this.AttributeIntercept, this.AttributeSlop);
      } else if (this.isABRGen) {
        AttrJSON = this.generateUTIXML('ABRGen', 'XML', this.AttributeCrt, this.AttributeCrtSD, this.AttributeAmpScore, this.AttributeCqConf, this.AttributeIntercept, this.AttributeSlop);
      } else if (!this.showeamp && !this.showSlop) {
        if (this.CTRecords.length > 0) {
          for (let cti = 0; cti < this.CTRecords.length; cti++) {
            const range = this.CTRecords[cti].range;
            const value = this.CTRecords[cti].value;
            this.CTRecords[cti].CTRange = range;
            this.CTRecords[cti].CTValue = value;
          }
        }
        AttrJSON = this.generateUTIXML('CT Range', 'XML', this.AttributeCrt, this.AttributeCrtSD, this.AttributeAmpScore, this.AttributeCqConf, this.AttributeIntercept, this.CTRecords);
      }
    }
    else {
      RadioType = this.ResultPropertiesSelected;
      if (this.ResultPropertiesSelected == 'Custom' || this.ResultPropertiesSelected == 'None') {
        AttrJSON = this.generateResultProperties(this.ResultPropertiesSelected);
        // if (AttrJSON.Properties.Property.length == 4 && this.ResultPropertiesSelected == 'Custom') {
        //    //empty
        // }
      } else {
        AttrJSON = '';
      }
    }

    
    let resObj = {
      'ID': this.action=='create' ? 0 :this.oldData.ID,
      'ResultCodeId': this.mainFormResultCodeFields?.resultCode?.ResultCodeId,
      'InstrumentId': this.action=='create' ? 0 :this.oldData.InstrumentId,
      'InstrumentTestCode': this.mainFormResultCodeFields.instrumentResultCodesMapper,
      'ImportResultProperties': this.ImportResultProperties,
      'OrderToDevice': this.mainFormResultCodeFields.resultMapping ? true : false,
      'ResultCode': this.mainFormResultCodeFields?.resultCode?.ResultCode == undefined ? '' : this.mainFormResultCodeFields?.resultCode?.ResultCode,
      'Importresultconfiguration': AttrJSON,
      'ImportresultconfigurationType': RadioType
    }
    if(!this.showAdditionAttr){
      if (resObj.ImportresultconfigurationType == 'None' || resObj.ImportresultconfigurationType == 'Custom') {
      if (resObj.Importresultconfiguration.Properties != undefined) {
        resObj.Importresultconfiguration = this.CreateResultPropertiesTypeSelectXML(resObj.Importresultconfiguration.Properties.Property);
      } else {
        resObj.Importresultconfiguration = this.CreateResultPropertiesTypeSelectXML([]);
      }
    } else {
      resObj.Importresultconfiguration = '';
    } 
      }

    // Update selectedResultFormValues with resObj data
    this.selectedResultFormValues = {
      ID: resObj.ID,
      ResultCodeId: resObj.ResultCodeId,
      InstrumentId: resObj.InstrumentId,
      InstrumentTestCode: resObj.InstrumentTestCode,
      ImportResultProperties: resObj.ImportResultProperties,
      OrderToDevice: resObj.OrderToDevice,
      ResultCode: resObj.ResultCode,
      Importresultconfiguration: resObj.Importresultconfiguration,
      ImportresultconfigurationType: resObj.ImportresultconfigurationType,
      OrderCodeID:this.selectedOrderCodeName?.OrderCodeID
    };
    if (this.action == 'create') {
      this.data.ResultCodeMapperList.push(this.selectedResultFormValues);
      this.addGridData(this.data.ResultCodeMapperList)
    }
    else {
      // Find index of existing record with matching ResultCodeId
      const existingIndex = this.data.ResultCodeMapperList.findIndex(
        item => item.ResultCodeId === this.selectedResultFormValues.ResultCodeId
      );

      if (existingIndex !== -1) {
        // Replace existing record
        this.data.ResultCodeMapperList[existingIndex] = this.selectedResultFormValues;
      } else {
        // Push new record if not found
        this.data.ResultCodeMapperList.push(this.selectedResultFormValues);
      }
      this.addGridData(this.data.ResultCodeMapperList)
    }
    this.saveOrEditCompleted = Math.floor(Math.random() * 500) + 1;

    // Reset form and return to grid view
    this.createPage = false;
  }

  private resetForm() {
    this.mainFormResultCodeFields = {
      resultMapping: false,
      resultCode: '',
      OrderCodeName: '',
      instrumentResultCodesMapper: ''
    };
    this.ResultProperties.forEach(prop => prop.value = false);
    this.ResultPropertiesCustom.forEach(prop => prop.value = false);
    this.resetAdditionalAttributes();
    this.isFormResultCodeChanges = false;
  }

  generateResultProperties(type) {
    var obj = {
      "Properties": { "Property": [] }
    }
    for (let RPT = 0; RPT < this.ResultPropertiesCustom.length; RPT++) {
      if (this.ResultPropertiesCustom[RPT].value && type == 'Custom') {
        obj.Properties.Property.push(this.ResultPropertiesCustom[RPT].alias);
      } else if (type == 'None') {
        obj.Properties.Property.push(this.ResultPropertiesCustom[RPT].alias);
      }
    }
    return obj;
  }

  generateUTIXML(AttType, Type, AttributeCrt, AttributeCrtSD, AttributeAmpScore, AttributeCqConf, AttributeIntercept, AmpSLOP) {
    var AttrXMLJSON: any;
    if (Type == 'XML') {
      var tempXML = [];
      if (AttributeCrt != "") {
        tempXML.push(`<Crt>${AttributeCrt}</Crt>`);
      } if (AttributeCrtSD != "") {
        tempXML.push(`<CrtSD>${AttributeCrtSD}</CrtSD>`);
      } if (AttributeAmpScore != "") {
        tempXML.push(`<AmpScore>${AttributeAmpScore}</AmpScore>`);
      } if (AttributeCqConf != "") {
        tempXML.push(`<CqConf>${AttributeCqConf}</CqConf>`);
      } if (AttributeIntercept != "") {
        tempXML.push(`<Intercept>${AttributeIntercept}</Intercept>`);
      }

      var XML = "";
      var XMLMAIN = '';
      if (AttType == 'EMP') {
        if (AmpSLOP != "") {
          tempXML.push(`<eAmp>${AmpSLOP}</eAmp>`);
        }
        XML = tempXML.join('');
        if (XML != "") {
          XMLMAIN = `<Attributes><Attribute>EMP</Attribute>${XML}</Attributes>`
        }
      } else if (AttType == "SLOPE") {
        if (AmpSLOP != "") {
          tempXML.push(`<Slope>${AmpSLOP}</Slope>`);
        }
        XML = tempXML.join('');
        if (XML != '') {
          XMLMAIN = `<Attributes><Attribute>SLOPE</Attribute>${XML}</Attributes>`
        }
      } else if (AttType == "ABRGen") {
        XML = tempXML.join('');
        if (XML != '') {
          XMLMAIN = `<Attributes>${XML}</Attributes>`
        }
      } else {
        let CTList = [];
        for (let cti = 0; cti < AmpSLOP.length; cti++) {
          CTList.push(`<CTRange Range="${AmpSLOP[cti].CTRange}" Value="${AmpSLOP[cti].CTValue}"/>`)
        }
        let CTListXMl = CTList.join('');
        XML = tempXML.join('');
        XMLMAIN = `<Attributes><Attribute>CT Range</Attribute>${XML}<CTRangeValues>${CTListXMl}</CTRangeValues></Attributes>`;
      }
      return XMLMAIN;
    } else {
      if (AttType == 'EMP') {
        return AttrXMLJSON = {
          "Attributes": {
            "Attribute": "EMP",
            "Crt": AttributeCrt,
            "CrtSD": AttributeCrtSD,
            "AmpScore": AttributeAmpScore,
            "CqConf": AttributeCqConf,
            "Intercept": AttributeIntercept,
            "eAmp": AmpSLOP
          }
        }
      } else if (AttType == 'SLOPE') {
        return AttrXMLJSON = {
          "Attributes": {
            "Attribute": "SLOPE",
            "Crt": AttributeCrt,
            "CrtSD": AttributeCrtSD,
            "AmpScore": AttributeAmpScore,
            "CqConf": AttributeCqConf,
            "Intercept": AttributeIntercept,
            "Slope": AmpSLOP
          }
        }
      } else if (AttType == "ABRGen") {
        return AttrXMLJSON = {
          "Attributes": {
            "Crt": AttributeCrt,
            "CrtSD": AttributeCrtSD,
            "AmpScore": AttributeAmpScore,
            "CqConf": AttributeCqConf
          }
        }
      } else {
        return AttrXMLJSON = {
          "Attributes": {
            "Attribute": "CT Range",
            "Crt": AttributeCrt,
            "CrtSD": AttributeCrtSD,
            "AmpScore": AttributeAmpScore,
            "CqConf": AttributeCqConf,
            "Intercept": AttributeIntercept,
            "CTRange": AmpSLOP
          }
        }
      }
    }
  }


  addResultCode() {
    if (this.data.InstrumentName != undefined) {
      this.ResultProperties.forEach(element => {
        element.value = false;
      });
      this.ResultAttributes.forEach(element => {
        element.value = false;
      });
      if (this.data.Selectedanalyzer == "EMP") {
        this.ResultAttributes[0].value = true;
        this.showAdditionAttr = true;
        this.showeamp = true;
        this.showSlop = false;
        this.CTRecords = [];
      } else if (this.data.Selectedanalyzer == "SLOPE") {
        this.ResultAttributes[1].value = true;
        this.showAdditionAttr = true;
        this.showSlop = true;
        this.showeamp = false;
        this.CTRecords = [];
      } else if (this.data.Selectedanalyzer == "CT Range") {
        this.ResultAttributes[2].value = true;
        this.showAdditionAttr = true;
        this.showSlop = false;
        this.showeamp = false;
        this.CTRecords.push({
          "CTRange": "",
          "CTValue": ""
        });
      }
      this.ResultPropertiesCustom.forEach(element => {
        element.value = true;
      });
    }
  }
  // Result Properties Type Selection
  ResultPropertiesTypeSelect(event, data, index) {
    if (event == true) {
      this.ResultPropertiesCustom[index].value = true;
    } else {
      this.ResultPropertiesCustom[index].value = false;
    }
    var allRPTrue = false;
    for (let allRP = 0; allRP < this.ResultPropertiesCustom.length; allRP++) {
      if (this.ResultPropertiesCustom[allRP].value == true) {
        allRPTrue = true;
      } else {
        allRPTrue = false;
        break;
      }
    }
    if (allRPTrue == true) {
      // this.ResultProperties.forEach(element => {
      //   element.value = false;
      // });
      this.ResultPropertiesCustom.forEach(element => {
        element.value = true;
      });
      this.ResultPropertiesSelected = 'Custom';
      this.ImportResultProperties = 'Do not Overwrite';
    } else {
      this.ImportResultProperties = 'Overwrite';
    }
  }

  CreateResultPropertiesTypeSelectXML(array) {
    var tempXMLArr = [];
    var tempXMLStr = '';
    var XML = null;
    if (array.length > 0) {
      for (let RPT = 0; RPT < array.length; RPT++) {
        tempXMLStr = `<Property>${array[RPT]}</Property>`;
        tempXMLArr.push(tempXMLStr);
      }
      XML = `<Properties>${tempXMLArr.join('')}</Properties>`;
    }
    return XML;
  }

  deleteResultOrderCodeMapper(event: any) {
    let dialogRef = this.dialog.open(ConfirmLabadminComponent, {
      disableClose: true,
      autoFocus: false,
      panelClass: 'admin-custom-popup',
      data: { header: "", message: "Permanently Delete Record", continue: "Delete", cancel: "Cancel" }
    })
    return dialogRef.afterClosed().toPromise().then(result => {
      if (result) {
        this.data.ResultCodeMapperList = this.data.ResultCodeMapperList.filter(item =>
          !(item.ResultCode === event.rowData.ResultCode && item.InstrumentTestCode === event.rowData.InstrumentTestCode)
        );

        this.addGridData(this.data.ResultCodeMapperList)
        this.saveOrEditCompleted = Math.floor(Math.random() * 500) + 1;

      }
    })
  }

  checkforSelectedanalyzer(value: string, jsonData?: any) {
    this.showAdditionAttr = (value === "EMP" || value === "SLOPE" || value === "CT Range");
  
    if (jsonData) {
      const attr = jsonData.Attributes?.Attribute;
  
      // ABR handling
      if (attr === "UTI ABR Genes") {
        this.isABRGen = true;
        this.showAdditionAttr = true;
      } else if (attr === "UTI Organism" || attr === "UTI Control Pathogen") {
        this.isABRGen = false;
      }
  
      if (this.isABRGen) {
        this.showeamp = false;
        this.showSlop = false;
        this.CTRecords = [];
        return;
      }
  
      // Common attributes patch
      this.AttributeCrt = jsonData.Attributes?.Crt ?? '';
      this.AttributeCrtSD = jsonData.Attributes?.CrtSD ?? '';
      this.AttributeAmpScore = jsonData.Attributes?.AmpScore ?? '';
      this.AttributeCqConf = jsonData.Attributes?.CqConf ?? '';
      this.AttributeIntercept = jsonData.Attributes?.Intercept ?? '';
  
      // CT Ranges
      if (attr === "CT Range") {
        this.showSlop = false;
        this.showeamp = false;
        this.CTRecords = [];
  
        const ctRangeValues = jsonData.Attributes?.CTRangeValues?.CTRange;
        if (Array.isArray(ctRangeValues)) {
          this.CTRecords = ctRangeValues.map(ct => ({
            range: ct['@Range'] || ct.Range,
            value: ct['@Value'] || ct.Value,
          }));
        } else if (ctRangeValues) {
          this.CTRecords.push({
            range: ctRangeValues['@Range'] || ctRangeValues.Range,
            value: ctRangeValues['@Value'] || ctRangeValues.Value,
          });
        }
      }
  
      // EMP
      if (attr === "EMP") {
        this.showeamp = true;
        this.showSlop = false;
        this.AttributeeAmp = jsonData.Attributes?.eAmp ?? '';
        this.CTRecords = [];
      }
  
      // SLOPE
      if (attr === "SLOPE") {
        this.showSlop = true;
        this.showeamp = false;
        this.AttributeSlop = jsonData.Attributes?.Slope ?? '';
        this.CTRecords = [];
      }
    }
  }
  
  
  parseXmlToJson(xmlString: string): any {
    const parser = new DOMParser();
    const xml = parser.parseFromString(xmlString, 'text/xml');
  
    const getTextContent = (tagName: string) => {
      const el = xml.getElementsByTagName(tagName)[0];
      return el ? el.textContent : null;
    };
  
    const getCTRangeValues = () => {
      const ranges = xml.getElementsByTagName('CTRange');
      const arr = [];
      for (let i = 0; i < ranges.length; i++) {
        const range = ranges[i].getAttribute('Range');
        const value = ranges[i].getAttribute('Value');
        arr.push({ Range: range, Value: value });
      }
      return arr;
    };
  
    return {
      Attributes: {
        Attribute: getTextContent('Attribute'),
        Crt: getTextContent('Crt'),
        CrtSD: getTextContent('CrtSD'),
        AmpScore: getTextContent('AmpScore'),
        CqConf: getTextContent('CqConf'),
        Intercept: getTextContent('Intercept'),
        CTRangeValues: {
          CTRange: getCTRangeValues()
        }
      }
    };
  }

  listPageStatusToggleInstrument(value: any) {
       const oldObject = structuredClone(value.rowData);
        this.data.ResultCodeMapperList = this.data.ResultCodeMapperList.map(item => {
          if (item.ResultCode === oldObject.ResultCode && item.InstrumentTestCode === oldObject.InstrumentTestCode) {
            return { ...item, OrderToDevice: item.OrderToDevice==false ? true : false };
          }
          return item;
        });
        this.addGridData(this.data.ResultCodeMapperList)
        this.saveOrEditCompleted = Math.floor(Math.random() * 500) + 1;
      }

  public InsCodes = [];

  InsCodesBlur(i, type, value) {
    if (type == 'Code') {
      this.InsCodes[i].instOrderCode = value;
    } else {
      this.InsCodes[i].instOrderName = value;
    }
  }
  removeCodes(code, i) {
    this.InsCodes.splice(i, 1);
  }
  addCodes() {
    this.InsCodes.push({
      "instOrderCode": '',
      "instOrderName": ''
    })
  }

}
